<template>
  <div class="h-100">
    <div class="d-flex flex-column h-100">
      <v-row
        v-if="$vuetify.breakpoint.mobile"
        class="m-2"
      >
        <v-col>
          <BtnClose @click="$emit('close')" />
        </v-col>
        <v-col
          cols="10"
          class="h5 font-weight-bold text-uppercase text-right"
        >
          {{ module.type != 'theme' ? module.subject.name : module.block.name }}
        </v-col>
      </v-row>
      <v-list-item
        v-for="(current_content, current_key) in contents"
        :key="current_key"
        class="border-bottom "
        :class="{
          'primary white--text' : current_key === activeTab,
          'cursor-pointer' : module.finished_at,
        }"
      >
        <v-list-item-content>
          <v-list-item-title
            class="d-flex align-items-center"
            @click="onClick(current_key, current_content)"
          >
            <img
              :src="`/images/${current_content.type}_content_icon${imgColor(current_content, current_key)}.svg`"
              width="25px"
              :class="{ 'inverted' : current_key === activeTab }"
            > 
            <span
              :class="{
                'ml-2': true,
                'text-wrap': true,
                'text-gray-550': current_key != activeTab,
                'font-weight-bold': current_content.finished_at || current_key == activeTab,
              }"
            >
              {{ current_content.order + 1 }}. {{ current_content.title }}
            </span>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-container>
        <v-row>
          <v-col :class="{'px-4':true, 'd-flex': $vuetify.breakpoint.mobile}">
            <VideocastButton v-if="module.type == 'theme'" />
            <EbookButton v-else />
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>

import { mapGetters } from "vuex";
import EbookButton from "./EbookButton.vue"
import VideocastButton from "./VideocastButton.vue"
import BtnClose from "@/common/components/BtnClose.vue";
import ActiveTabMixin from "./ActiveTabMixin";

export default {
  components:{
    BtnClose,
    EbookButton,
    VideocastButton
  },
  mixins:[ActiveTabMixin],
  computed: {
    ...mapGetters(['module','contents']),
    ebook(){
      return this.module.ebook;
    },
  },
  methods:{
    onClick(key_value){
      if (this.module.finished_at) {
        this.activeTab = key_value
      }
    },
    imgColor(current_content, current_key){
      if (current_key == this.activeTab) {
        return ''
      }
      if (current_content.finished_at) {
        return '_blue'
      }
      return '_gray'
    },
  }
}
</script>
